import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BudgetService } from '@app/models/budgets/budgets.service';
import { Notification } from '@app/models/notifications/notifications.model';
import { GaugeData } from '@app/shared/gauge/component';
import { BudgetRanges } from '@app/notifications/notifications-index/constants';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-budget-notification',
    templateUrl: './budget.component.html',
    styleUrls: ['../notification-types.scss'],
})
export class BudgetNotificationComponent implements OnInit {
    @Input() entitlement: string = null;
    @Input() notification: Notification = { extra: {} } as Notification;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();
    gaugeData: Record<number, GaugeData> = {};

    constructor(private budgets: BudgetService, private router: Router, private route: ActivatedRoute) {}

    ngOnInit() {
        this.notification.extra.percentage = Number(this.notification.extra.percentage);
        this.gaugeData[this.notification.id] = {
            values: [
                this.notification.extra.percentage,
                this.notification.extra.percentage > 100 ? 0 : 100 - this.notification.extra.percentage,
            ],
            text: Number(this.notification.extra.percentage).toFixed(0),
            subtext: '',
            color: this.notification.hexColor,
        };
    }

    navigateToBudgetRange() {
        const bucket = this.notification.extra.budget_type.toLowerCase();
        const start = DateTime.fromISO(this.notification.created_datetime);
        const timezone = DateTime.fromISO(this.notification.created_datetime).zoneName;
        const queryScale = BudgetRanges[bucket].scale;
        const queryStart = BudgetRanges[bucket].since(start).setZone(timezone).toISO();
        const queryUntil = BudgetRanges[bucket].until(start).setZone(timezone).toISO();

        const params: Record<string, string> = {};
        params.since = queryStart;
        params.until = queryUntil;
        params.scale = queryScale;
        params.new = 'true';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: params,
        });
    }
}
